import { inIframe as e } from "../deviceUtils.js";
//#region src/utils/init/initConfig.ts
var t = e(), n = (e) => console.debug(e);
//#endregion
export { n as debug, t as isInIframe };

//# sourceMappingURL=initConfig.js.map